import assign from './assign/index.js'
import defineProperties from './define-properties/index.js'
import defineProperty from './define-property/index.js'
import freeze from './freeze/index.js'
import seal from './seal/index.js'
export default {
  assign,
  defineProperties,
  defineProperty,
  freeze,
  seal,
}